export default {
    // User module common translations
    user_management: 'User Management',
    user_list: 'User List',
    user_info: 'User Information',
    user_edit: 'Edit User',
    user_create: 'Create User',
    user_delete: 'Delete User',
    user_search: 'Search User',
    user_import: 'Import User',
    user_export: 'Export User',

    // Form fields and placeholders
    enter_name_phone: 'The name/phone number of the conference attendee',
    select_checkin_status: 'Please select the check-in status',
    all: 'All',
    checked_in: 'Checked In',
    not_checked_in: 'Not Checked In',

    // Table columns
    reg_no: 'Registration Number',
    representative_name: 'Representative Name',
    mobile: 'Mobile Phone',
    order_count: 'Order Quantity',
    gender: 'Gender',
    organization: 'Affiliated Organization',
    nationality: 'Nationality',
    region: 'Region',
    email: 'Email',
    reg_time: 'Registration Time',
    operation: 'Operation',

    // Actions
    add: 'Add',
    import_user: 'Import User',
    export: 'Export',
    search: 'Search',
    details: 'Details',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',

    // Messages
    tips: 'Tips',
    confirm_delete: 'Are you sure you want to delete this user?',
    save_success: 'Save Successful',
    delete_success: 'Delete Successful',
    import_success: 'Import Successful',
    export_success: 'Export Successful',

    // User info component
    edit_profile: 'Edit Profile',
    basic_info: 'Basic Information',
    ticket_orders: 'Ticket Orders',
    hotel_orders: 'Hotel Orders',
    travel_info: 'Travel Information',
    add_order: 'Add Order',
    add_hotel_order: 'Add Hotel Order',

    // Order status
    order_no: 'Order Number',
    goods_name: 'Product Name',
    order_amount: 'Order Amount',
    payment_status: 'Payment Status',
    payment_method: 'Payment Method',
    refund_status: 'Refund Status',
    none: 'None',

    // Payment and refund status
    pending_payment: 'Pending Payment',
    paid: 'Paid',
    refund_completed: 'Refund Completed',
    refunding: 'Refunding',
    refund_rejected: 'Refund Rejected',
    not_refunded: 'Not Refunded',

    // Review status
    pending_review: 'Pending Review',
    approved: 'Approved',
    rejected: 'Rejected',
    no_review_needed: 'No Review Needed',
    audit_status_title: 'Review status',
    audit_btn_text: 'Review',
    select_audit_status: 'Please select the review status',
    audit_error: 'Reject',
    submit_audit: 'Confirm',
    audit_success: 'Pass',
    // Form fields
    username: 'Username',
    password: 'Password',
    phone: 'Phone Number',
    status: 'Status',
    create_time: 'Creation Time',
    update_time: 'Update Time',

    // Status
    status_active: 'Active',
    status_inactive: 'Inactive',

    // Validation messages
    required_field: 'This field is required',
    invalid_email: 'Please enter a valid email address',
    invalid_phone: 'Please enter a valid phone number',

    // User edit component
    add_user: 'Add User',
    search_user: 'Search User',
    search_user_tip: 'Please search for user information before adding a new user to check if it already exists.',
    enter_name: 'Please enter the user name',
    enter_mobile: 'Please enter the phone number',
    enter_company: 'Please enter the work unit',
    add_new_user: 'Add New User',
    add_success: 'Add Successful',
    chinese_guest: 'Chinese Guest',
    foreign_guest: 'Foreign Guest',

    // Add order component
    description: 'Description',
    discount_info: 'Discount Information',
    to: 'To',
    add_success: 'Add Successful',
    create_hotel_order: 'Create Hotel Order',
    create_success: 'Create Successful',

    // Create order component
    create_order: 'Create Order',
    user_id: 'User ID',
    channel: 'Channel',
    select_channel: 'Please select the channel',
    goods: 'Goods',
    select_goods: 'Please select the goods',
    select_payment: 'Please select the payment method',
    select_payment_status: 'Please select the payment status',

    // Edit order component
    edit_order: 'Edit Order',
    order_id: 'Order ID',
    upload_file: 'Upload File',
    view: 'View',
    operation_success: 'Operation Successful',
    upload_doc_image: 'Only doc, docx formats and images can be uploaded',
    file_size_limit: 'File size cannot exceed 3M',

    // Identity edit component
    edit_config: 'Edit Configuration',
    add_config: 'Add Configuration',
    config_info: 'Configuration Information',
    config_tip: 'You can edit the configuration only after disabling it in the application.',
    config_id: 'Configuration ID',
    enter_config_id: 'Please enter the configuration ID',
    identity_type: 'Identity Type Name',
    enter_identity_type: 'Please enter the identity type name',
    verify_method: 'Verification Method',
    select_verify_method: 'Please select the verification method',
    api_verify: 'API Verification',
    manual_verify: 'Manual Verification',
    verify_url: 'API Verification URL',
    enter_verify_url: 'Please enter the API verification URL',

    // Import modal component
    import: 'Import',
    data_validation: 'Data Validation',
    select_validation_type: 'Please select the data validation type',
    validate_data: 'Validate data authenticity',
    no_validate_data: 'Do not validate data authenticity',
    upload_data: 'Upload Data',
    upload_file: 'Upload File',
    clear: 'Clear',
    download_template: 'Download Template',
    error_tip: 'Error Tip',
    only_excel: 'Only Excel files are supported for upload',
    upload_valid_excel: 'Please upload a valid Excel file',

    // Import data table columns
    import_name: 'Imported Data - Name',
    import_mobile: 'Imported Data - Mobile',
    import_email: 'Imported Data - Email',
    import_org: 'Imported Data - Organization',
    system_name: 'System Data - Name',
    system_mobile: 'System Data - Mobile',
    system_email: 'System Data - Email',
    system_org: 'System Data - Organization',

    // Route info component
    arrival_info: 'Arrival Information',
    departure_info: 'Departure Information',
    accommodation_info: 'Accommodation Information',
    departure_time: 'Departure Time',
    arrival_time: 'Arrival Time',
    transport_type: 'Transportation Type',
    flight_number: 'Flight/Train Number',
    departure_city: 'Departure City',
    destination: 'Destination',
    hotel_name: 'Hotel Name',
    room_type: 'Room Type',
    room_name: 'Room Name',
    check_in_time: 'Check-in Time',
    check_out_time: 'Check-out Time',
    no_data: 'No Data',

    // User form component
    name: 'Name',
    enter_name: 'Please enter the name',
    mobile_number: 'Mobile Number',
    enter_mobile: 'Please enter the mobile number',
    invalid_mobile: 'Invalid mobile number format',
    nationality: 'Nationality',
    gender: 'Gender',
    select_gender: 'Please select the gender',
    male: 'Male',
    female: 'Female',
    email: 'Email',
    enter_email: 'Please enter the email',
    invalid_email: 'Invalid email format',
    organization: 'Affiliated Organization',
    enter_organization: 'Please enter the affiliated organization',
    avatar: 'Avatar',
    upload_avatar: 'Please upload the avatar',
    upload_image: 'Upload Image',
    image_only: 'You can only upload image files',
    mobile_exists: 'This mobile number already exists',
    region: 'Region',
    profile: 'Personal Profile',
    enter_profile: 'Please enter the personal profile',

    // VIP module specific translations
    vip_management: 'VIP Management',
    vip_list: 'VIP List',
    vip_info: 'VIP Information',
    vip_edit: 'Edit VIP',
    vip_create: 'Create VIP',
    vip_delete: 'Delete VIP',
    vip_search: 'Search VIP',
    vip_import: 'Import VIP',
    vip_export: 'Export VIP',
    vip_details: 'VIP Details',
    vip_status: 'VIP Status',
    vip_level: 'VIP Level',
    vip_points: 'VIP Points',
    vip_expiry_date: 'VIP Expiry Date',
    vip_benefits: 'VIP Benefits',
    vip_notes: 'VIP Notes',

    // Identity module specific translations
    identity_verification_desc: "Identity verification: The process by which the portal platform verifies the user's identity within a specified society or organization.",
    application_status: 'Application Status',
    status_disabled: 'Disabled',
    status_enabled: 'In Use',
    disable: 'Disable',
    enable: 'Enable',
    confirm_delete_identity: 'Are you sure you want to delete this identity type?',
    index: 'Serial Number',
    identity_name: 'Identity Name',
    treatment_name: 'Treatment name',
    p_cn_tips: 'Please enter the Chinese object prompt',
    p_en_tips: 'Please enter the prompt for foreign guests',
    cn_tips: 'Chinese guest prompt',
    en_tips: 'Prompt for foreign guests'
};
